export var PremiumFeatureModalType;
(function (PremiumFeatureModalType) {
    PremiumFeatureModalType[PremiumFeatureModalType["UpgradePrompt"] = 0] = "UpgradePrompt";
    PremiumFeatureModalType[PremiumFeatureModalType["UpgradeSuccess"] = 1] = "UpgradeSuccess";
    PremiumFeatureModalType[PremiumFeatureModalType["SuperDemo"] = 2] = "SuperDemo";
})(PremiumFeatureModalType || (PremiumFeatureModalType = {}));
